import { BIFROST_ENABLED_LOCALES, useIdentityContext } from '@99designs/design-services-common';
import { getCountryCode } from '@99designs/i18n';
import { NavigationTracking } from '@99designs/tracking';
import { DesignProductPresenter } from './presenter/types';

type TrackingData = Pick<PageTracking, 'pageName' | 'pageStage' | 'pageSection'> & {
    pagePath: string;
    pageZone: string;
    position?: number;
    linkHierarchy?: string;
    crossPlatformTracking?: string;
    isHolidayHub?: boolean;
};

export const getNavigationData = (
    product: DesignProductPresenter,
    trackingData: TrackingData
): NavigationTracking => {
    let ctaValue = product.name.replace(/\s+/g, '');
    if (trackingData.linkHierarchy) {
        ctaValue = `${trackingData.linkHierarchy}|${ctaValue}`;
    }

    return {
        category: trackingData.pageSection,
        label: `Content: ${trackingData.pageZone}`,
        eventDetail: `${trackingData.pagePath};${product.ctaUrl('en-US')};${
            trackingData.pageZone
        };${ctaValue}`,
        navigationDetail: `${trackingData.isHolidayHub ? 'Holiday|' : ''}${ctaValue}${
            trackingData.position ? `:${trackingData.position}` : ''
        }`,
        pageSection: trackingData.pageSection,
        pageStage: trackingData.pageStage,
        pageName: trackingData.pageName,
        crossPlatformTracking: trackingData.crossPlatformTracking,
    };
};

export function useCrossPlatformTracking(locale: string, content: string): URLSearchParams | null {
    const countryCode = getCountryCode(locale);
    const { anonymousUserId } = useIdentityContext();

    if (BIFROST_ENABLED_LOCALES.includes(locale)) {
        return null;
    }

    const searchParams = new URLSearchParams();
    searchParams.set('utm_content', content);
    searchParams.set('utm_campaign', `Design-Services-${countryCode}`);
    searchParams.set('aid', anonymousUserId);

    return searchParams;
}
